import { Link } from 'react-router-dom';
import './InfoCard.css';

export default function InfoCard({
  icon,
  title,
  titleAs: TitleTag = 'h3',
  description,
  to,
  href,
  onClick,
  variant = 'default',
  className = '',
  children,
}) {
  const inner = (
    <>
      {icon && (
        <span className="info-card-icon" aria-hidden="true">
          {icon}
        </span>
      )}
      <div className="info-card-body">
        <TitleTag className="info-card-title">{title}</TitleTag>
        {description && (
          <p className="info-card-description">{description}</p>
        )}
        {children}
      </div>
    </>
  );

  const cls = `info-card info-card--${variant}${to || href || onClick ? ' info-card--interactive' : ''} ${className}`.trim();

  if (to) {
    return (
      <Link to={to} className={cls}>
        {inner}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={cls}>
        {inner}
      </a>
    );
  }

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={cls}>
        {inner}
      </button>
    );
  }

  return <div className={cls}>{inner}</div>;
}
